module.exports = __webpack_public_path__ + "static/media/logo_clave_unica.b18a7bcd.svg";